/**
 * recently-viewed.js
 * Tracks viewed products in localStorage and renders a carousel
 * on both the homepage and product detail page.
 *
 * Storage key: 'tpc_rv' → JSON array of product objects (max 12, newest first)
 * Each product object: { id, handle, title, url, image, price, type }
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'tpc_rv';
  var MAX_ITEMS   = 12;

  /* ── Helpers ─────────────────────────────────────────────────── */

  function getRV() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveRV(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
    catch (e) { /* quota errors — silently ignore */ }
  }

  function formatPrice(raw) {
    /* raw is `product.price` from Liquid, in cents — already the real,
       catalog-adjusted INR price for the visitor's market (Shopify Market
       Catalogs apply any markup before this JS ever sees it). This only
       converts for DISPLAY into the visitor's local currency, whole
       numbers only — no markup math here. */
    if (!raw && raw !== 0) return '';
    var inr = raw / 100;
    if (window._currencyConverter && typeof window._currencyConverter.formatFromINR === 'function') {
      return window._currencyConverter.formatFromINR(inr, window._currencyConverter.getCurrentCurrency());
    }
    var country = (window.ShopifyMarket && window.ShopifyMarket.country) || 'IN';
    var displayRates = { US: [0.0104, '$'], GB: [0.0082, '£'], CA: [0.0142, 'C$'], AU: [0.0159, 'A$'], AE: [0.0382, 'AED '], IN: [1, '₹'] };
    var pair = displayRates[String(country)] || displayRates.US;
    var converted = Math.round(inr * pair[0]);
    return pair[1] + converted.toLocaleString('en-US');
  }

  /* ── Track current product (product pages only) ──────────────── */

  function trackCurrentProduct() {
    var meta = document.getElementById('tpc-rv-meta');
    if (!meta) return;                // not a product page
    var data;
    try { data = JSON.parse(meta.textContent); } catch (e) { return; }
    if (!data || !data.id) return;

    var list = getRV().filter(function (p) { return p.id !== data.id; });
    list.unshift(data);
    if (list.length > MAX_ITEMS) list.length = MAX_ITEMS;
    saveRV(list);
  }

  /* ── Build card HTML ─────────────────────────────────────────── */

  function buildCard(p) {
    var imageUrl = p.image ? String(p.image) : '';
    if (imageUrl) imageUrl += (imageUrl.indexOf('?') === -1 ? '?' : '&') + 'width=600';
    var img = p.image
      ? '<img src="' + esc(imageUrl) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="750" decoding="async">'
      : '<div class="rv-card__img-placeholder"></div>';
    var priceHtml = p.price !== undefined
      ? '<p class="rv-card__price" data-base-price="' + (p.price / 100) + '">' + formatPrice(p.price) + '</p>'
      : '';
    var typeHtml = p.type
      ? '<p class="rv-card__type">' + esc(p.type) + '</p>'
      : '';
    return (
      '<a href="' + esc(p.url) + '" class="rv-card" aria-label="' + esc(p.title) + '">' +
        '<div class="rv-card__media">' + img + '</div>' +
        '<div class="rv-card__body">' +
          typeHtml +
          '<h3 class="rv-card__title">' + esc(p.title) + '</h3>' +
          priceHtml +
          '<span class="rv-card__cta">View details <svg width="14" height="10" viewBox="0 0 14 10" fill="none" aria-hidden="true"><path d="M8.5 0.5L13 5L8.5 9.5" stroke="currentColor" stroke-width="1.3"/><path d="M13 5H0.5" stroke="currentColor" stroke-width="1.3"/></svg></span>' +
        '</div>' +
      '</a>'
    );
  }

  function esc(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /* ── Render into a container ─────────────────────────────────── */

  function render(container, excludeId) {
    var list = getRV().filter(function (p) {
      return !excludeId || p.id !== excludeId;
    });

    if (list.length < 1) {
      container.closest('.rv-section') && (container.closest('.rv-section').style.display = 'none');
      return;
    }

    /* Show the section now that we have items */
    var section = container.closest('.rv-section');
    if (section) section.style.display = '';

    var html = list.map(buildCard).join('');
    var track = container.querySelector('.rv-track');
    if (track) track.innerHTML = html;

    /* Set up prev/next arrows — they live in .rv-section-head, a sibling
       of .rv-carousel-wrap, so look them up from the whole section. */
    var prev = section.querySelector('.rv-arrow--prev');
    var next = section.querySelector('.rv-arrow--next');
    var viewport = container.querySelector('.rv-viewport');
    if (!prev || !next || !viewport) return;

    var SCROLL_AMOUNT = 300;
    prev.addEventListener('click', function () { viewport.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' }); });
    next.addEventListener('click', function () { viewport.scrollBy({ left:  SCROLL_AMOUNT, behavior: 'smooth' }); });

    function updateArrows() {
      prev.disabled = viewport.scrollLeft < 4;
      next.disabled = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 4;
    }
    viewport.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  /* ── Init ────────────────────────────────────────────────────── */

  function init() {
    trackCurrentProduct();

    /* Get excludeId from meta tag if present */
    var meta = document.getElementById('tpc-rv-meta');
    var excludeId;
    try { excludeId = meta ? JSON.parse(meta.textContent).id : null; } catch (e) {}

    var containers = document.querySelectorAll('.rv-carousel-wrap');
    containers.forEach(function (el) { render(el, excludeId); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
